import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { changeShowModal } from '../../../store/actions/SideMenu';
import { PrivateRoutes } from '../../../utils/constants/routes';
import { Button } from '../../FormComponents/Button/Button';
import s from '../style/modalStyle.module.scss';

export const ModalAddAdvertising = ({...props}) => {
  const {otherParams} = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const backToPage = () => {
    dispatch(
      changeShowModal({
        nameModal: 'newAdvertising',
        stateModal: false,
        otherParams: undefined,
      }),
    );
    history.push(PrivateRoutes.advertising.list);
  };
  return (
    <div className={s.modalBox}>
      <div className={s.title}> Done!</div>
      <div className={s.description}>
        New Promo Advertising was successfully published
      </div>
      <Button
        text="Back to Advertising list"
        type="submit"
        class_type="secondary"
        onClick={() => backToPage()}
      />
    </div>
  );
};
